export default {
  SET_ORDER_ID: 'SET_ORDER_ID',
  SET_ORDER_ACTION_TEXT: 'SET_ORDER_ACTION_TEXT',
  SET_ALL_ORDER_HASH_MAP: 'SET_ALL_ORDER_HASH_MAP',
  SET_PREVIOUS_DRINK_HASH_MAP: 'SET_PREVIOUS_DRINK_HASH_MAP',
  SET_PREVIOUS_FOOD_HASH_MAP: 'SET_PREVIOUS_FOOD_HASH_MAP',
  SET_PREVIOUS_EQUIPMENT_HASH_MAP: 'SET_PREVIOUS_EQUIPMENT_HASH_MAP',
  SET_CURRENT_DRINK_HASH_MAP: 'SET_CURRENT_DRINK_HASH_MAP',
  SET_CURRENT_FOOD_HASH_MAP: 'SET_CURRENT_FOOD_HASH_MAP',
  SET_CURRENT_EQUIPMENT_HASH_MAP: 'SET_CURRENT_EQUIPMENT_HASH_MAP',
  SET_ALL_CURRENT_HASH_MAP: 'SET_ALL_CURRENT_HASH_MAP',
  SET_CONFIRM_ITEMS: 'SET_CONFIRM_ITEMS',
  SET_IS_EDIT_ORDER: 'SET_IS_EDIT_ORDER',
  RESET_ALL_ORDER: 'RESET_ALL_ORDER',
}
